import http from 'plugins/axios';

export default {
  // getAuditList(data) {
  //   return http.get({
  //     url: '/la/admin/workorder/deposite_audit_List',
  //     data
  //   });
  // },
  
  gethashList(data) {
    return http.get({
      // url: '/la/admin/workorder/deposite_tranfer_query',
      url: '/la/admin/otc/transactionHistory',
      data
    });
  },
  getTotalInfo(data) {
    return http.get({
      // url: '/la/admin/workorder/deposite_tranfer_query',
      url: '/la/admin/otc/getTotal',
      data
    });
  },
  getAllCoins() {
    return http.get({
      url: '/la/admin/coin/coin-list'
    });
  }
};
